<template>
  <div
    class="d-flex pa-0 ma-0 align-center"
    :style="{
      'max-width': MobileSize ? '75%' : '60%',
    }"
  >
    <v-card class="rounded" color="transparent" flat tile>
      <v-card
        class="pa-2 black--text"
        color="grey lighten-2"
        :style="{
          'white-space': 'pre-line',
        }"
        >{{ message.text }}</v-card
      >
    </v-card>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn small icon v-bind="attrs" :disabled="!Editing" v-on="on">
          <v-icon>more_vert</v-icon>
        </v-btn>
      </template>
      <v-card max-width="300" :height="QuestionList.length > 1 ? 200 : undefined">
        <v-list>
          <v-list-item @click="edittext = true">
            <v-list-item-title>แก้ไข</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$delete(QuestionList, index)">
            <v-list-item-title>ลบ</v-list-item-title>
          </v-list-item>
          <div v-if="QuestionList.length > 1">
            <v-divider></v-divider>
            <v-subheader>สลับคำถาม</v-subheader>
            <v-list-item
              v-for="(item, i) in QuestionList.filter(
                (t) => t.type !== 'quickReply'
              )"
              @click="movequestion(i)"
              :key="i"
            >
              <v-list-item-title>{{
                item.type === "image"
                  ? `รูปภาพที่ ${i + 1}`
                  : item.type === "video"
                  ? `วิดีโอที่ ${i + 1}`
                  : item.text
              }}</v-list-item-title>
            </v-list-item>
          </div>
        </v-list>
      </v-card>
    </v-menu>

    <EditText
      :visible="edittext"
      :message="message"
      @close="edittext = false"
    />
  </div>
</template>
<script>
import EditText from "./EditText";
export default {
  props: [
    "message",
    "hover",
    "conversation",
    "index",
    "Editing",
    "QuestionList",
  ],
  components: { EditText },
  data() {
    return {
      edittext: false,
    };
  },
  computed: {
    MobileSize() {
      const { xs } = this.$vuetify.breakpoint;
      return xs ? true : false;
    },
  },
  methods: {
    movequestion(indexmove) {
      let index = this.index;
      let moveindex = indexmove;
      let old_index = index;
      let new_index = moveindex;
      if (new_index >= this.QuestionList.length) {
        var k = new_index - this.QuestionList.length + 1;
        while (k--) {
          this.QuestionList.push(undefined);
        }
      }
      this.QuestionList.splice(
        new_index,
        0,
        this.QuestionList.splice(old_index, 1)[0]
      );
    },
  },
};
</script>
